import {Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {ClinicalDashboardService} from "@ispm-client/modules/clinical-dashboard/services/clinical-dashboard.service";
import {Subject} from "rxjs";
import {get, findIndex} from 'lodash';

@Component({
  selector: 'ispm-clinical-trends-filter',
  templateUrl: './clinical-trends-filter.component.html',
  styleUrls: ['./clinical-trends-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClinicalTrendsFilterComponent implements OnInit, OnDestroy {

  public selectedFilter: string;
  public rangeDates: Date[];
  private destroyed$: Subject<any> = new Subject();
  private selectedIndex = null;
  public isRightRangeEnabled = false;
  public isLeftRangeEnabled = true;
  public startDate: Date;
  public endDate: Date;
  public filters = [{
    "code": "all",
    "display": "All"
  }, {
    "code": "oneDay",
    "display": "Today"
  }, {
    "code": "oneWeek",
    "display": "1 week"
  }, {
    "code": "oneMonth",
    "display": "1 month"
  }, {
    "code": "oneYear",
    "display": "1 year"
  }, {
    "code": "custom",
    "display": "Custom timeframe"
  }];

  constructor(private _clinicalDashboardService: ClinicalDashboardService,
              private _cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this._clinicalDashboardService.getFilterStore()
      .takeUntil(this.destroyed$.asObservable())
      .map(filterData => get(filterData, 'type'))
      .subscribe(type => {
        let selectedClinicalDashboard = sessionStorage.getItem("selectedClinicalDashboard").replace(" ","").toLowerCase();
        let selectedIndexTemp = parseInt(sessionStorage.getItem('filter'+selectedClinicalDashboard));
        if (Number.isSafeInteger(selectedIndexTemp) && selectedIndexTemp >= 0) {
          if (this.selectedIndex != selectedIndexTemp) {
            this.selectedIndex = selectedIndexTemp;
            this.selectedFilter = get(this.filters, `[${this.selectedIndex}].code`);
            sessionStorage.setItem('filter' + selectedClinicalDashboard, this.selectedIndex.toString());
            if (this.selectedFilter != 'custom') {
              this.rangeDates = this._clinicalDashboardService.getDateRanges(this.selectedFilter);
              this.startDate = this.rangeDates[0];
              this.endDate = this.rangeDates[1];
              this._clinicalDashboardService.updateFilterStore(this.selectedFilter);
            }
          }
        } else {
          if (this.selectedFilter != type) {
            this.selectedFilter = type;
            this.selectedIndex = findIndex(this.filters, item => item.code == this.selectedFilter);
            if (this.selectedFilter != 'custom') {
              this.rangeDates = this._clinicalDashboardService.getDateRanges(this.selectedFilter);
              this.startDate = this.rangeDates[0];
              this.endDate = this.rangeDates[1];
            }
          }

        }
        this.checkNavigationAvailability();
        this._cd.markForCheck();
      });
  }

  /**
   * On selection of filter
   * @param selectedFilter
   */
  onSelectedFilter(selectedFilter) {
    if (this.selectedFilter == 'all') {
      this.rangeDates = [new Date(), new Date()];
    }
    this.selectedFilter = selectedFilter;
    this.checkNavigationAvailability();
    this.selectedIndex = findIndex(this.filters, item => item.code == this.selectedFilter);
    let selectedClinicalDashboard = sessionStorage.getItem("selectedClinicalDashboard").replace(" ","").toLowerCase();
    sessionStorage.setItem('filter'+selectedClinicalDashboard, this.selectedIndex.toString());
    if (this.selectedFilter != 'custom') {
      this.rangeDates = this._clinicalDashboardService.getDateRanges(this.selectedFilter);
      this.startDate = this.rangeDates[0];
      this.endDate = this.rangeDates[1];
      this._clinicalDashboardService.updateFilterStore(this.selectedFilter);
    }
  }

  /**
   * Custom date change
   */
  onSelectDateRange() {
    if (this.rangeDates && this.rangeDates.length == 2 && this.rangeDates[0] && this.rangeDates[1]) {
      this._clinicalDashboardService.updateFilterStore('custom', this.rangeDates);
    }
  }

  /**
   * On Range selection change date ranges
   * @param isIncreament
   */
  onRangeSelection(isIncreament) {
    let initialDate;
    if (isIncreament) {
      initialDate = this.rangeDates[1];
    }
    if (!isIncreament) {
      initialDate = this.rangeDates[0];
    }
    this.rangeDates = this._clinicalDashboardService.getDateRanges(this.selectedFilter, initialDate, isIncreament);
    this.startDate = this.rangeDates[0];
    this.endDate = this.rangeDates[1];
    this._clinicalDashboardService.updateFilterStore(get(this.filters, `[${this.selectedIndex}].code`), this.rangeDates);
    this.checkNavigationAvailability();
  }

  /**
   * Check navigation availability
   */
  checkNavigationAvailability() {
    if (this.selectedFilter == 'custom' || this.selectedFilter == 'all') {
      this.isRightRangeEnabled = false;
      this.isLeftRangeEnabled = false;
    } else {
      this.isRightRangeEnabled = true;
      this.isLeftRangeEnabled = true;
      if (this.rangeDates && this.rangeDates.length == 2 && this._clinicalDashboardService.isToday(this.rangeDates[1])) {
        this.isLeftRangeEnabled = false;
      }
    }
  }


  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }


}
